import styled from '@emotion/styled';
import Typography from '@portalterreno/react-ui-core/Typography';

const StyledTypography = styled(Typography)({}, ({ theme }) => ({
  a: {
    color: theme.palette.colors.midnightBlue,
    textDecoration: 'underline',
    fontWeight: theme.typography.fontWeightLight,
    fontSize: theme.typography.fontSize.small
  }
}));

export default StyledTypography;
